import Quill from "quill";

const BlockEmbed = Quill.import("blots/block/embed");

class ReplyBlot extends BlockEmbed {
  static blotName = "replyPreview";

  static tagName = "div";

  static className = "reply-preview";

  static create(value) {
    const node = super.create();

    node.setAttribute("data-id", value.id);
    node.setAttribute("contenteditable", false);

    const wrapper = document.createElement("div");
    wrapper.className = "reply-preview-content";

    const textWrapperDiv = document.createElement("div");
    textWrapperDiv.className = "reply-preview-text-wrapper";
    wrapper.appendChild(textWrapperDiv);

    const userDiv = document.createElement("div");
    userDiv.className = "reply-preview-user";
    userDiv.style.fontWeight = "bold";
    userDiv.textContent = value.user;
    textWrapperDiv.appendChild(userDiv);

    const div = document.createElement("div");
    div.className = "reply-preview-text";
    div.textContent = value.text;
    textWrapperDiv.appendChild(div);

    const btn = document.createElement("button");
    btn.className = "reply-remove";
    btn.type = "button";
    btn.textContent = "×";
    wrapper.appendChild(btn);

    node.appendChild(wrapper);
    return node;
  }
}

Quill.register(ReplyBlot);

export default ReplyBlot;